import WithSystem from './../service/WithSystem';
class ProductTypeDropDown extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {}    
    this.productType = { 'filter_all': 'All Type', '1': 'Course', '2': 'Bundle', '3': 'Training Event', '4': 'General' } 
  }
  setSelectedProductType = (id) => { 
    this.props.setGlobalState({ 'product_type': id, 'old_product_type': this.props.queryFilter.product_type, 'product_id': '', 'product_name': '' });
    __filter_applied= true; 
    $("#bc-datatable").DataTable().state.clear();
  }

  render() {
    return (          
      <div className="rTableCell dropdown">
        <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <span id="filter_course">{this.productType[this.props.queryFilter.product_type] != undefined?`${this.productType[this.props.queryFilter.product_type]}`:`All Type`}</span> 
          <span className="caret"></span>
        </a>
        <ul className="dropdown-menu white inner-scroll">          
          <li><a href="#" id="filter_all" onClick={() => this.setSelectedProductType('')}>All Type</a></li>
          <li><a href="#" id="filter_course" onClick={() => this.setSelectedProductType(1)}>Course</a></li>
          <li><a href="#" id="filter_bundle" onClick={() => this.setSelectedProductType(2)}>Bundle</a></li>
          <li><a href="#" id="filter_training_event" onClick={() => this.setSelectedProductType(3)}>Training Event</a></li>
          <li><a href="#" id="filter_general" onClick={() => this.setSelectedProductType(4)}>General</a></li>
        </ul>
      </div>
    );  
  }  
}
export default WithSystem(ProductTypeDropDown);

